module.exports = __webpack_public_path__ + "img/come-vict-09.c1bc9d81.jpg";